// eslint-disable-next-line no-shadow
enum ETipoDocumentoOnboarding {
  CNH = 'CNH',
  CNH_VERSO = 'CNH_VERSO',
  SELFIE = 'SELFIE',
  PROCURACAO = 'PROCURACAO',
  ESTATUTO_SOCIAL = 'ESTATUTO_SOCIAL',
  CONTRATO_SOCIAL = 'CONTRATO_SOCIAL',
  DECLARACAO_BENEFICIARIOS_FINAIS = 'DECLARACAO_BENEFICIARIOS_FINAIS',
}

export default ETipoDocumentoOnboarding
